/* global AP */

import { hosts } from './hosts'
import { continueWithSave } from './JiraAdapterHelpers'

const initialExampleMap = { 'rules': [[]], 'questions': [], 'notes': { text: '' } }

export default class JiraConnectAdapter {
  constructor () {
    this.lastKnownExampleMap = ''
    this.jiraKey = ''
  }

  async load () {
    const loadStart = Date.now()
    const issueKey = await this.fetchIssueKey()
    this.jiraKey = issueKey
    
    let exampleMap = await this.fetchExampleMap(`/rest/api/2/issue/${issueKey}/properties/tul-em`)
    window.amplitude.getInstance().logEvent('em_load_examplemap', { 'issue_key': issueKey, loadTime: Date.now() - loadStart })
    if (exampleMap === null) {
      exampleMap = initialExampleMap
    }
    this.lastKnownExampleMap = JSON.stringify(exampleMap)
    
    if (exampleMap.rules.length === 0) {
      exampleMap.rules[0] = []
    }

    return exampleMap
  }

  async save (state, options) {
    let allowOverwrite = true
    if (typeof options !== 'undefined' && typeof options.allowOverwrite !== 'undefined') {
      allowOverwrite = options.allowOverwrite
    }
    const stateToSaveStringified = JSON.stringify(state)

    if (stateToSaveStringified === this.lastKnownExampleMap) {
      // nothing to save, so don't save and risk a save collision
      return false
    }
    const propertyUrl = '/rest/api/2/issue/' + this.jiraKey + '/properties/tul-em'

    // check if we are saving with a fresh version. If not optionally reload.
    const continueResult = await continueWithSave(allowOverwrite, this.lastKnownExampleMap, () => this.fetchExampleMap(propertyUrl))
    if (continueResult.reload) {
      return true
    }
    if (!continueResult.continueWithSave) {
      return false
    }

    const saveStart = Date.now()
    await AP.request({
      url: propertyUrl,
      type: 'PUT',
      contentType: 'application/json',
      data: stateToSaveStringified
    })
    window.amplitude.getInstance().logEvent('em_save_examplemap', { saveTime: Date.now() - saveStart })
    this.lastKnownExampleMap = stateToSaveStringified
    return false
  }

  async fetchExampleMap (propertyUrl) {
    try {
      const response = await AP.request(propertyUrl)
      return JSON.parse(response.body).value
    } catch (error) {
      if (error.xhr && error.xhr.status === 404) {
        return null
      } else {
        console.log(error)
        throw error
      }
    }
  }

  async fetchSummary () {
    try {
      const issueKey = await this.fetchIssueKey()
      const response = await AP.request(`/rest/api/3/issue/${issueKey}?fields=summary`)
      const objectResult = JSON.parse(response.body)
      return objectResult.fields.summary
    } catch (error) {
      if (error.xhr && error.xhr.status === 404) {
        return null
      } else {
        console.log(error)
        throw error
      }
    }
  }

  async fetchIssueKey () {
    let issueKey = ''
    let response = await AP.context.getContext()
    issueKey = response.jira.issue.key
    return issueKey
  }

  async getCustomerIdentifier () {
    return new Promise(
      (resolve, reject) => {
        try {
          AP.getLocation(location => {
            location = location.substr(location.indexOf('//') + 2)
            location = location.split('.')[0]
            resolve(location)
          })
        } catch (err) {
          console.log(err)
          window.amplitude.getInstance().logEvent('em_cannot_get_customer')
          reject(err)
        }
      }
    )
  }

  getHost () {
    return hosts.JIRA_CONNECT
  }

  async loadInitialExampleMap () {
    return initialExampleMap
  }

  async openEditor (closeCallback) {
    AP.require('dialog', function (dialog) {
      dialog.create({
        key: 'dialog-module-em-edit',
        chrome: false,
        width: '100%',
        height: '100%',
        size: 'maximum'
      }).on('close', closeCallback)
    })
  }

  async closeEditor () {
    AP.dialog.close()
  }
}
